import { Parser } from '~/api';
import { ApiKey } from '~/api/models';
import RequestService from './request';

interface CreateApiKeyRequest {
    memo: string;
    allowed_ips?: string;
}

interface DeleteApiKeyRequest {
    id: string;
}

class ApiKeysService {
    getAll(req: PaginatableRequest): Promise<ListResponse> {
        return RequestService.get('/security/credentials', req).then(Parser.parse);
    }

    create(data: CreateApiKeyRequest): Promise<ApiKey> {
        return RequestService.post('/security/credentials', data).then(Parser.parse);
    }

    delete(data: DeleteApiKeyRequest) {
        return RequestService.delete(`/security/credentials/${data.id}`);
    }
}

export default new ApiKeysService();
